export default __webpack_public_path__ + "static/speaker2-7124531445ae9fc293a50630868ed2c9.jpg";